import React, { ReactElement } from "react";
import { Link } from "react-router-dom";

import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";

interface Props {
    slug: string;
    title: string;
    description: string;
    subject: any;
    widthClass: string;
}

export default function SubjectLink({
    description,
    slug,
    subject,
    title,
    widthClass,
}: Props): ReactElement {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <Link
            className={`${widthClass} square-link`}
            to={`/modquiz/subjects/${subject.user}/${subject.slug}/${slug}`}
        >
            <Typography
                aria-owns={open ? "mouse-over-popover" : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
            >
                {title}
            </Typography>
            <Popover
                id="mouse-over-popover"
                classes={{
                    root: "popover",
                    paper: "popover-paper"
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
                sx={{
                    pointerEvents: "none",
                    "& .MuiPaper-root": {
                        padding: 1
                    }
                }}
            >
                <Typography>{description}</Typography>
            </Popover>
        </Link>
    );
}
